/**
 * RISKS.ACTIONS
 * List of actions
 */
import NavApp from "@/nav/nav.app"
import PageHeader from "@/components/page-header"
import PagePlaceholder from "@/components/page-placeholder"
function RisksUpdatesActionsRoute() {
  return (
    <NavApp>
      <PageHeader title="Actions" subtitle="Suivez et gérez les actions mises en place dans le cadre du Papripact." />
      <PagePlaceholder
        image="coming-soon"
        title="Disponible prochainement"
        help="Cette fonctionnalité n'est pas encore disponible dans la version actuelle de IDTree."
      />
    </NavApp>
  )
}

export default RisksUpdatesActionsRoute
